export default function reversed<T>(array: Array<T>): Array<T> {
  return [...array].reverse();
}
